import { panelThemeClasses } from "../../theme/themeClasses";

/** @deprecated Use the semantic Tailwind tokens directly (bg-surface, bg-card, text-content, border-line…). */
export const buildThemeClasses = (isDarkMode?: boolean) => {
  void isDarkMode;
  return panelThemeClasses();
};
